import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export function SAGoalsFeatureGate(props: Props) {
    return (
        <FeatureGateModalWrapper
            isOpen={props.isOpen}
            onClose={() => props.setIsOpen(false)}
            title='Define the purpose of each stage in your pipeline'
            description='Give your team a clear measure of progress with specific goals to be met in each pipeline stage.'
            bullets={[
                'Define goals for your team to meet at every step of the sales process.',
                'Automatically advance leads to the next pipeline stage when they meet the goal.',
            ]}
            feature='salesAutomationGoals'
        />
    );
}
